import { useEffect, useState } from "react";
import * as S from "./styles";
import { ButtonLink } from "../../../elements/ButtonLink";

export default function PlansTabs({
  content,
  planos,
  planIndex = 0,
  planOptionIndex = 0,
  title = "Planos UOL Play disponíveis",
  hiddenSubtitle = false,
  hiddenReceba40 = false,
  planTypeText = "anual",
  refPlanos
}) {
  const [selectedPlan, setSelectedPlan] = useState(planos[planIndex]);
  const [optionIndex, setOptionIndex] = useState(planOptionIndex);

    useEffect(() => {
    if (planos[planIndex]) {
      setSelectedPlan(planos[planIndex]);
    }
  }, [planIndex, planos]);

  return (
    <S.Section>
      <S.Title>{title}</S.Title>
      <S.SubTitleDiv>
        {!hiddenSubtitle && (
          <S.SubTitle $hiddenSubtitle={hiddenSubtitle}>
            <span>
              <S.Bold>Ganhe R$ 20 todo mês</S.Bold>em cinema na
            </span>
            <span>
              <S.ImgIngresso
                src="https://imguol.com.br/p/pp/uol-play/nova-pv/planos/logo_ingresso.svg"
                alt="Logo Ingresso.com"
              />
              no plano {planTypeText}
            </span>
          </S.SubTitle>
        )}

        <S.BenefitsDiv>
          Todos incluem:
          <S.Benefits>
            {content?.map((content) => (
              <S.Benefit key={content.id}>
                <S.ImgBenefit src={content.imgSrc} alt={content.alt} />
                <S.TextBenefit>{content.text}</S.TextBenefit>
              </S.Benefit>
            ))}
          </S.Benefits>
        </S.BenefitsDiv>
      </S.SubTitleDiv>

      <S.PlansContainer id="planos" >
        {planos.length > 1 && (
          <S.Tabs>
            {planos.map((plano) => (
              <S.Tab
                key={plano.id}
                $active={selectedPlan.id === plano.id}
                onClick={() => setSelectedPlan(plano)}
                $borderColor={plano.borderColor}
              >
                {plano.name}
                {selectedPlan.id !== plano.id ? (
                  <S.TabInfo>
                    A partir de R$ <p>{plano?.startingPrice}</p> /mês
                  </S.TabInfo>
                ) : null}
              </S.Tab>
            ))}
          </S.Tabs>
        )}

        <S.Content $borderColor={selectedPlan.borderColor}>
          <S.Description $uniqueOption={planos.length === 1}>
            {planos.length === 1 && <h4>{selectedPlan.name}</h4>}
            <p>{selectedPlan.description}</p>
            <S.Logos $uniqueOption={planos.length === 1}>
              <img src={selectedPlan.logosDesk} alt="Logos" />
            </S.Logos>
          </S.Description>

          <S.PriceBox>
            {selectedPlan.options.map((option, index) => (
              <>
                {option.id === "monthly" ? (
                  <S.MonthlyPrice
                    $borderColor={selectedPlan.borderColor}
                    $isSelected={optionIndex === index}
                    onClick={() => setOptionIndex(index)}
                  >
                    <S.RadioWrapper $isSelected={optionIndex === index}>
                      <input
                        type="radio"
                        name={selectedPlan.options[optionIndex].id}
                        id={selectedPlan.options[optionIndex].id}
                        checked={optionIndex === index}
                      />
                      <label htmlFor="plansMonthly">
                        {selectedPlan.options[index].name}
                      </label>
                    </S.RadioWrapper>
                    <S.Price $isSelected={optionIndex === index}>
                      <span> R$ {selectedPlan.options[index].price}</span>
                      {selectedPlan.options[index].suffixOption}
                    </S.Price>
                  </S.MonthlyPrice>
                ) : (
                  <S.AnnualPrice
                    $borderColor={selectedPlan.borderColor}
                    $isSelected={optionIndex === index}
                    onClick={() => setOptionIndex(index)}
                  >
                    <S.DivRadio>
                      <S.Discount
                        $borderColor={selectedPlan.borderColor}
                        $isSelected={optionIndex === index}
                      >
                        {selectedPlan.options[index].discount}% de desconto
                      </S.Discount>
                      <S.RadioWrapper $isSelected={optionIndex === index}>
                        <input
                          type="radio"
                          name={selectedPlan.options[optionIndex].id}
                          id={selectedPlan.options[optionIndex].id}
                          checked={optionIndex === index}
                        />
                        <label htmlFor="plansAnnual">
                          {selectedPlan.options[index].name}
                        </label>
                      </S.RadioWrapper>
                    </S.DivRadio>
                    <S.DivPrice hiddenReceba40={hiddenReceba40}>
                      <S.Price $isSelected={optionIndex === index}>
                        {selectedPlan.options[index].installments} de R${" "}
                        <span>{selectedPlan.options[index].price}</span>{" "}
                      </S.Price>
                      <S.TotalPrice>
                        Total R$ {selectedPlan.options[index].totalPrice}
                        {selectedPlan.options[index].suffixOption}
                      </S.TotalPrice>
                      {!hiddenReceba40 && (
                        <S.CinemaOffer $isSelected={optionIndex === index}>
                          <S.Bold>Ganhe R$ 20</S.Bold> <p>na ingresso.com</p>
                        </S.CinemaOffer>
                      )}
                    </S.DivPrice>
                  </S.AnnualPrice>
                )}
              </>
            ))}

            <ButtonLink
              as="a"
              href={selectedPlan.options[optionIndex].ctaUrlDesk}
              text={selectedPlan.options[optionIndex].ctaText}
              size="pv"
            />
          </S.PriceBox>
        </S.Content>
      </S.PlansContainer>
    </S.Section>
  );
}
